// removed by extract-text-webpack-plugin
module.exports = {"Btn":"hnSQGgijFX7Xy1y-fGWAX","Icon":"_1WxmNV9IpUQE2h-Nf6ToB_"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Utils/UI/Button/styles.module.css
// module id = 599
// module chunks = 0